import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const BankedIcon = (props: IconProps) => (
  <ChakraIcon
    width="12"
    height="8"
    viewBox="0 0 48 31"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <rect
      opacity="0.3"
      x="0.5"
      y="0.5"
      width="47"
      height="30"
      rx="3.5"
      stroke="#999999"
    />
    <circle cx="23.583" cy="20.6664" r="2.58339" fill="#B1B4B9" />
    <circle cx="23.5832" cy="10.3334" r="2.58339" fill="#B1B4B9" />
  </ChakraIcon>
);
